export { ProductNew as default } from './product-new';
